import { CountUp } from 'countup.js';
// import { Odometer } from 'odometer_countup';

function wrapIntegersInSpan(node) {
    const text = node.textContent;

    // This regular expression finds numbers that can be negative,
    // contain comma separators, and have decimal parts.
    // -?         -> Optional negative sign
    // \d{1,3}    -> 1 to 3 digits to start
    // (?:,?\d{3})* -> Groups of an optional comma and 3 digits, repeated 0 or more times
    // (?:\.\d+)? -> An optional decimal part
    // g          -> Global flag to find all matches
    const numberRegex = /-?\d{1,3}(?:,?\d{3})*(?:\.\d+)?/g;

    // Find all string segments that match the regex.
    const matches = text.match(numberRegex);

    // If no matches are found, return an empty array.
    if (!matches) {
        return;
    }

    // we're going to assume only one match
    const number = matches[0];
    const numberInt = parseInt(number.replace(',', ''), 10);
    const newHtml = text.replace(number, `<span data-countup-int="${numberInt}">${number}</span>`);

    node.innerHTML = newHtml;
}

export default function CountAnimation() {
    const counters = document.querySelectorAll('[data-countup]');
    counters.forEach(node => {
        // we can't rely on text data being a number
        wrapIntegersInSpan(node);

        // we'll assume there's only one number
        const numNode = node.querySelector('[data-countup-int]');

        if (numNode) {
            const countUp = new CountUp(
                numNode,
                node.dataset.countupInt,
                {
                    enableScrollSpy: true,
                    duration: 3,
                    scrollSpyDelay: 0,
                    scrollSpyOnce: true,
                },
            );
            countUp.start();
        }
    });
}
